
import { Component, Prop, Vue } from 'nuxt-property-decorator'

interface IconComponent {
  icon : string
  label : string
}

@Component({
  name: 'EventHeader',
  components: { BaseIcon: () => import('./base/BaseIcon.vue') },
})
export default class EventHeader extends Vue {
  @Prop() date ?: string

  @Prop({ default: () => [] }) labels! : string[]

  @Prop() location ?: string

  @Prop({ default: '/' }) delimiter! : string

  @Prop({ default: false }) showIcons! : boolean

  @Prop({ default: 'row' }) flexDirection! : 'row' | 'col'

  private get components () : IconComponent[] {
    const comps : IconComponent[] = []
    const add = (icon : string, label ?: string) => !!label && comps.push({ icon, label })
    add('calendar-days', this.date)
    add('location-dot', this.location)
    add('tags', this.displayLabels)
    return comps
  }

  private get displayLabels () : string {
    return this.labels.join(` ${this.delimiter} `)
  }
}
